import React from 'react';
function InternalServerError (props) {
    return (
        <div className="overlay-message-wrapper">
            <div className="main-icon">
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 48 48" style={{'enableBackground':'new 0 0 48 48'}} space="preserve">
                    <g>
                        <path className="st0" d="M24,0.1c-6.4,0-23.7,32-23.7,41.1c0.1,9.2,47.5,9.2,47.5,0C47.7,32.2,30.4,0.1,24,0.1z M27.1,14.7l-0.8,17.5h-4.5l-0.8-17.5H27.1z M24,41.6c-1.8,0-3.2-1.5-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.5,3.2,3.2C27.3,40.1,25.8,41.6,24,41.6z" />
                    </g>
                </svg>
            </div>
            <h5 className="splunk-h5 overlay-title-padding">Oh No.<br />We’re experiencing a bit of trouble.</h5>
            <p className="splunk-body">Please try again later.</p>
        </div>
    )
}
export default InternalServerError;